<template>
<div class="h-dialogContainer">
  <div class="row">
    <div class="col-sm-6">
      <div class="h-borderBox height-260">
        <div class="h-borderTree-pm-content">
          <NeTreeForCreate ref="NeTreeForCreate" @showTypeChange="showTypeChange" :neIdsUnderTaskByTaskId="neIdsUnderTaskByTaskId" :addOrModifyTaskFlag="addOrModifyTaskFlag"></NeTreeForCreate>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="h-borderBox height-260">
        <div class="h-borderTree-pm-content">
          <MeasureTreeForCreate ref="MeasureTreeForCreate" :measureObjTreeShowType="measureObjTreeShowType"></MeasureTreeForCreate>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <div class="h-btnBox">
        <ejs-button id="btnFive1" iconCss="icon hero-icon hero-icon-double-down" cssClass="h-btn-put" :isPrimary="true" v-on:click.native="addMeasureObj">{{$t('Pm.addToFollow')}}</ejs-button>
      </div>
    </div>
  </div>
  <div class="row">
      <MeasureListForCreate id="MeasureListForCreate" ref="MeasureListForCreate"></MeasureListForCreate>
  </div>
</div>
</template>

<script>
import NeTreeForCreate from '../NeTreeForCreate';
import MeasureTreeForCreate from '../MeasureTreeForCreate';
import MeasureListForCreate from '../MeasureListForCreate';
import { EventBus } from '../../../../../plugins/eventBus';

export default {
  name: 'AddOrModifyTaskDialog2',
  props: [
    'addOrModifyTaskFlag',
    'paramsOfFirstStep',
    'neIdsUnderTaskByTaskId'
  ],
  data() {
    return {
      measureObj: [],
      measureObjTreeShowType: 0,
      treeGridList: []
    };
  },
  components: {
    NeTreeForCreate,
    MeasureTreeForCreate,
    MeasureListForCreate
  },
  methods: {
    showTypeChange(msg) {
      if (msg == 1) {
        this.$refs.MeasureTreeForCreate.init();
      }
      this.measureObjTreeShowType = msg;
    },

    addMeasureObj() {
      this.treeGridList = [];

      // 获取网元树中选中的网元节点信息
      const NeTreeForCreate = this.$refs.NeTreeForCreate.$refs.neTreeForCreate;
      const selectedNodesOfNeTree = NeTreeForCreate.ej2Instances.selectedNodes;
      const neSelect = NeTreeForCreate.getTreeData(selectedNodesOfNeTree[0])[0];

      // 过滤树中的非网元节点
      if (!neSelect || !neSelect.attributes || !neSelect.attributes.neId) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.pleaseSelectResource') });
        return;
      }

      // 组装选中的网元树节点信息
      const neObj = {
        id: neSelect.attributes.neId,
        neName: neSelect.attributes.neName,
        neType: this.paramsOfFirstStep.neType,
        measureObjectTypeName: '',
        meterTimePeriod: '',
        parentItem: null,
        isParent: true
      }

      // 获取测量对象树中选中的测量对象节点信息
      let measureObj = null;
      let MeasureObjTreeForCreate = this.$refs.MeasureTreeForCreate.$refs.MeasureObjTreeForCreate;
      const checkNodesOfMeasureObjTree = MeasureObjTreeForCreate.getAllCheckedNodes();

      // 过滤树中的非网测量对象节点
      if (checkNodesOfMeasureObjTree.length == 0) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectMOplease') });
        return;
      } else {
        this.treeGridList.push(neObj);
      }

      for (let i = 0; i < checkNodesOfMeasureObjTree.length; i++) {
        // 获取选中节点信息
        const nodeChecked = MeasureObjTreeForCreate.getTreeData(checkNodesOfMeasureObjTree[i])[0];

        // 筛除掉父级非测量对象节点
        if (nodeChecked.children.length > 0) {
          continue;
        }

        // 将选中的测量对象节点信息存入measureObj中
        measureObj = {
          id: nodeChecked.id,
          neName: neSelect.attributes.neName,
          neType: this.paramsOfFirstStep.neType,
          measureObjectTypeName: nodeChecked.text,
          meterTimePeriod: this.paramsOfFirstStep.meterTimePeriod,
          configMeasureObjectTypeSub: nodeChecked.attributes,
          neTypeId: nodeChecked.attributes.neTypeId,
          neVersionId: nodeChecked.attributes.neVersionId,
          counterTypeId: nodeChecked.attributes.counterTypeId,
          neId: neSelect.attributes.neId,
          parentItem: neSelect.attributes.neId,
          isParent: false
        }

        // 将measureObj存入treeGridList中作为treeGrid的子节点
        this.treeGridList.push(measureObj);
        measureObj = null;
      }

      // 更新加载表格的数据源
      this.$refs.MeasureListForCreate.dataOfList = this.treeGridList;
    }
  }
};
</script>

<style>
  .h-dialogContainer .h-borderBox {
    border: 1px solid #d9d9d9;
    border-radius: 3px;
  }
</style>
